import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/toast.css";
import EcommLayout from "./layout/EcommLayout";
import UserLayout from "./layout/UserLayout";
// Ecommerce Imports

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import RootRoute from "./routes/RootRoute";
import HomePage from "./ecommerce/pages/homepage/HomePage";
import SearchPage from "./ecommerce/globalcomponents/HomeNavbar/SearchPage";
import SignInPage from "./ecommerce/pages/SignInPage/SignInPage";
import SignUpPage from "./ecommerce/pages/SignUpPage/SignUpPage";
import ForgotPasswordPage from "./ecommerce/pages/ForgotPasswordPage/ForgotPasswordPage";
import DetailPage from "./ecommerce/pages/detailpage/DetailPage";
import Categories from "./ecommerce/pages/productlisting/categorie/Categories";
import SubCategorie from "./ecommerce/pages/productlisting/subcategorie/SubCategorie";
import ChildCategorie from "./ecommerce/pages/productlisting/childcategorie/ChildCategorie";
import CartPage from "./ecommerce/pages/CartPage/CartPage";
import CheckoutPage from "./ecommerce/pages/Checkout/CheckoutPage/CheckoutPage";
import MiniCategories from "./ecommerce/pages/mobilecategories/MiniCategories";
import Orders from "./ecommerce/pages/account/orders/Orders";
import TrackPackage from "./ecommerce/pages/account/trackPackage/TrackPackage";
import DeliveryFeedBack from "./ecommerce/pages/account/deliveryfeedback/DeliveryFeedBack";
import SubmitReview from "./ecommerce/pages/account/productreviewcreate/submitReview";
// User Imports
import Dashboard from "./user/pages/dashboard/Dashboard";
// Personal Detail Imports
import PersonalInformationPage from "./user/pages/MyAccount/PersonalInformationPage/PersonalInformationPage";
import KycPage from "./user/pages/MyAccount/KycPage/KycPage";
import Kyc from "./user/pages/account/Kyc";
import GlobalKyc from "./user/pages/account/GlobalKyc";
import ChangePassword from "./user/pages/MyAccount/ChangePasswordPage/ChangePasswordPage";
import ChangeTxnPassword from "./user/pages/MyAccount/ChangeTransactionPasswordPage/ChangeTransactionPasswordPage";
// Manage Address Imports
import ManageAddress from "./user/pages/manageaddress/ManageAddress";
// Team Imports

// Portfolio Imports
import Portfolio from "./user/pages/portfolio/Portfolio";
// My Orders Imports
import MyOrders from "./user/pages/orders/MyOrders";
// My Stuff Imports
import SalarShopVoucher from "./user/pages/stuff/shoppingvoucher/SalarShopVoucher";
import Gifts from "./user/pages/stuff/gifts/Gifts";
import LikedStores from "./user/pages/stuff/likedstores/LikedStores";
import ReviewStores from "./user/pages/stuff/reviewstores/ReviewStores";
import Offers from "./user/pages/stuff/Offers";
import Subscriptions from "./user/pages/stuff/Subscriptions";
import LuckyDraw from "./user/pages/stuff/LuckyDraw";
// My Earnings Imports
import ReferralCommission from "./user/pages/earnings/referralCommisson/ReferralCommission";
import ReferralCommissoinTeam from "./user/pages/earnings/referralCommisson/referralCommTeamTable/ReferralCommissoinTeam";
import ReferralCommLevel from "./user/pages/earnings/referralCommisson/referralcommleveltable/ReferralCommLevel";
// import Tree from "./user/pages/tree/Tree";
import NovaCommissionTeam from "./user/pages/earnings/novareferralteam/novacommteam/NovaCommissionTeam";
import NovalLevelTeam from "./user/pages/earnings/novareferralteam/novalevelteam/NovalLevelTeam";
import PrtCommisson from "./user/pages/earnings/prtcommission/PrtCommisson";
import MrcCommissons from "./user/pages/earnings/mrccommissions/MrcCommissons";
import DailyCommissons from "./user/pages/earnings/dailycommissoin/DailyCommissons";
import SalarCoins from "./user/pages/earnings/salarcoins/SalarCoins";

// Wallet Imports
import SalarPay from "./user/pages/wallet/SalarPay";
import FundTransfer from "./user/pages/wallet/FundTransfer";
import RecievedFunds from "./user/pages/wallet/recievedfunds/RecievedFunds";
import SalarWalletPage from "./user/pages/wallet/SalarWalletPage/SalarWalletPage";

// Withdrawl Imports
import WithdrawlRequest from "./user/pages/withdrawl/WithdrawlRequest";
import WithdrawlHistory from "./user/pages/withdrawl/withdrawlhistory/WithdrawlHistory";
import BankAccVerification from "./user/pages/withdrawl/bankverification/BankAccVerification";
// Tickets Imports
import Tickets from "./user/pages/support/Tickets";
import CreateTickets from "./user/pages/support/CreateTickets";
// Testimonial Imports
import UserTestimonials from "./user/pages/testimonials/UserTestimonials";
import CreateTestimonials from "./user/pages/testimonials/CreateTestimonials";
import UpdateTestimonial from "./user/pages/testimonials/updateTestimonial";
// Games Imports
import PlayGames from "./user/pages/games/PlayGames";
// Close Account Imports
import CloseAccount from "./user/pages/closeAccount/CloseAccount";
import DeActivateAccount from "./user/pages/closeAccount/DeActivateAccount";
import DailyCommissoinDetails from "./user/pages/earnings/dailycommissoin/dailycommdetails/DailyCommissoinDetails";
import PrtCommissonDetails from "./user/pages/earnings/prtcommission/prtcommissiondetails/PrtCommissonDetails";
import OrderDetails from "./user/pages/orders/OrderDetails";
import ShoppingVoucherDetails from "./user/pages/stuff/shoppingvoucher/ShoppingVoucherDetails";
import GiftDetails from "./user/pages/stuff/gifts/GiftDetails";
import LikedStoreDetails from "./user/pages/stuff/likedstores/LikedStoreDetails";
import ReferralCommDetails from "./user/pages/earnings/referralCommisson/referralCommTeamTable/ReferralCommDetails";
import MrcCommissonDetails from "./user/pages/earnings/mrccommissions/MrcCommissonDetails";
import SalarCoinsDetails from "./user/pages/earnings/salarcoins/SalarCoinsDetails";
import ShoppingAmount from "./user/pages/earnings/shoppingamount/ShoppingAmount";
import ShoppingAmountDetail from "./user/pages/earnings/shoppingamount/ShoppingAmountDetail";
import CreditDebit from "./user/pages/wallet/creditdebit/CreditDebit";
import FundTransferHistoryDetails from "./user/pages/wallet/fundtransferhistory/FundTransferHistoryDetails";
import WithdrawlHistoryDetails from "./user/pages/withdrawl/withdrawlhistory/WithdrawlHistoryDetails";
import SponsorCommission from "./user/pages/earnings/sponsorcommission/SponsorCommission";
import ReferralIncentive from "./user/pages/earnings/referralincentive/ReferralIncentive";
import AusComm from "./user/pages/earnings/auscommission/AusComm";
import TicketMessage from "./user/pages/support/TicketMessage";
// Footer Imports
import CorporateInfo from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/CorporateInfo";
import OurLeadership from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/OurLeadership";
import OurLeadershipInside from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/OurLeadershipInside";
import LeadershipPrinciples from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/LeadershipPrinciples";
import Crs from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/Crs";
import Ethics from "./ecommerce/globalcomponents/footer/footerpages/discoverus/aboutus/corporateinfo/Ethics";
import EmployeeBenifits from "./ecommerce/globalcomponents/footer/footerpages/discoverus/ourworkplace/EmployeeBenifits";
import Diversity from "./ecommerce/globalcomponents/footer/footerpages/discoverus/ourworkplace/Diversity";
import OurEmployees from "./ecommerce/globalcomponents/footer/footerpages/discoverus/ourworkplace/OurEmployees";
import Brands from "./ecommerce/globalcomponents/footer/footerpages/discoverus/brands/Brands";
import WorkWithUs from "./ecommerce/globalcomponents/footer/footerpages/discoverus/career/WorkWithUs";
import Jobs from "./ecommerce/globalcomponents/footer/footerpages/discoverus/career/Jobs";
import JobsInside from "./ecommerce/globalcomponents/footer/footerpages/discoverus/career/JobsInside";
import Magzines from "./ecommerce/globalcomponents/footer/footerpages/magzines/Magzines";
import MagzinesInside from "./ecommerce/globalcomponents/footer/footerpages/magzines/MagzinesInside";
import PayoutReport from "./user/pages/withdrawl/payout-report/PayoutReport";
import Tax from "./user/pages/withdrawl/tax/Tax";
import OfferDetails from "./user/pages/stuff/OfferDetails";
import SubscriptionDetails from "./user/pages/stuff/SubscriptionDetails";
import UserPayout from "./user/pages/payouts/UserPayout";
import UserPayoutsTwo from "./user/pages/payouts/UserPayoutsTwo";
import CustomerFundTransferReciept from "./user/pages/payouts/CustomerFundTransferReciept";
import AdminFunTransferReciept from "./user/pages/payouts/AdminFunTransferReciept";
// import Partners from "./ecommerce/globalcomponents/footer/footerpages/discoverus/partners/partners";
// import Blogs from "./ecommerce/globalcomponents/footer/footerpages/blogs/Blogs";
// import Blogsinsides from "./ecommerce/globalcomponents/footer/footerpages/blogs/Blogsinsides";
// import Media from "./ecommerce/globalcomponents/footer/footerpages/medias/media";
// import ContentPageforallFooterLinks from "./ecommerce/globalcomponents/footer/footerpages/ContentPageforallFooterLinks";
import Advertisement from "./ecommerce/pages/AdsAnsUpdate/Advertisement";
import Tree from "./user/pages/tree/Tree";
import SalarUnity from "./user/pages/earnings/salarunity/SalarUnity";
import SalarUnityDetails from "./user/pages/earnings/salarunity/SalarUnityDetails";

import RecievedFudsDetails from "./user/pages/wallet/recievedfunds/RecievedFudsDetails";
import Games from "./user/pages/games/Games";

import CategoryBanner from "./ecommerce/pages/productlisting/categorie/catagoryBanner";
import ProductList from "./ecommerce/pages/productlistpage/productlist";
import FundTransferHistory from "./user/pages/wallet/fundtransferhistory/FundTransferHistory";
import SellerDetail from "./ecommerce/pages/sellerPages/SellerDetail";
import SellerListing from "./ecommerce/pages/sellerPages/SellerListing";
import SellerPage from "./ecommerce/pages/sellerPages/seller-page/SellerPage";
import RefProduct from "./ecommerce/pages/RefProduct/RefProduct";
import Refproductdetails from "./ecommerce/pages/ref-product-detail/Refproductdetails";
import FoodOrderList from "./user/pages/orders/FoodOrderList/FoodOrderList";
import FoodOrderDetails from "./user/pages/orders/FoodOrderList/FoodOrderDetails";
import FoodSellerFeeback from "./user/pages/orders/FoodOrderList/FoodSellerFeeback/FoodSellerFeeback";
import FoodProductFeedback from "./user/pages/orders/FoodOrderList/FoodProductFeedback/FoodProductFeedback";
import FoodDeliveryFeedback from "./user/pages/orders/FoodOrderList/FoodDeliveryFeedback/FoodDeliveryFeedback";
import MyInvitationsPage from "./user/pages/MyNetwork/MyInvitationsPage/MyInvitationsPage";
import LoginasAdmin from "./ecommerce/pages/registerpages/LoginasAdmin";
import SalarSamriddhiPage from "./user/pages/MyNetwork/SalarSamriddhiPage/SalarSamriddhiPage";
import SalarSamriddhiMilestonePage from "./user/pages/MyNetwork/SalarSamriddhiPage/SalarSamriddhiMilestonePage";
import PartnerGrowth from "./user/pages/MyNetwork/partnerGrowth/PartnerGrowth";
import PartnerGrowthIncentives from "./user/pages/earnings/partnergrowthincentive/PartnerGrowthIncentives";
import DigitalProductDetails from "./ecommerce/pages/Digital-product/Digital-productdetails";
import DigitalProductPage from "./ecommerce/pages/Digitalproductlisting/DigitalproductPage";
import BookAppointment from "./ecommerce/pages/book-appointment/BookAppointment";
import DoctorPro from "./ecommerce/pages/book-appointment/DoctorPro";
import CustomerDetails from "./ecommerce/pages/book-appointment/CustomerDetails";
import Invoice from "./ecommerce/globalcomponents/Invoice/Invoice";
import CustRefPayInvoice from "./ecommerce/globalcomponents/Invoice/CustRefPayInvoice";
import SellRefPayInvoice from "./ecommerce/globalcomponents/Invoice/SellRefPayInvoice";
import BrowserHistory from "./ecommerce/pages/additionalpages/browserhistory/BrowserHistory";
import SubsOrderDetail from "./user/pages/orders/SubsOrderDetail";
import ScrollToTop from "./ScrollToTop";
import LoyaltyRefIncentive from "./user/pages/earnings/sponsorcommission/LoyaltyReferralIncentives/LoyaltyRefIncentive";
import WishlistPage from "./ecommerce/pages/WishlistPage/WishlistPage";
import OrdersPage from "./ecommerce/pages/OrdersPage/OrdersPage";
import ProductDetailPage from "./ecommerce/pages/ProductDetailPage/ProductDetailPage";
import ProductReviewPage from "./ecommerce/pages/ProductReviewPage/ProductReviewPage";
import OrderDetailsPage from "./ecommerce/pages/OrderDetailsPage/OrderDetailsPage";
import TrackPackagePage from "./ecommerce/pages/TrackPackagePage/TrackPackagePage";
import CategoryListingPage from "./ecommerce/pages/CategoryListingPage/CategoryListingPage";
import BuyAgainPage from "./ecommerce/pages/BuyAgainPage/BuyAgainPage";
import TodaysDealsPage from "./ecommerce/pages/TodaysDealsPage/TodaysDealsPage";
import SellerBrandPage from "./ecommerce/pages/SellerBrandPage/SellerBrandPage";
import SellerInfoPage from "./ecommerce/pages/SellerInfoPage/SellerInfoPage";
import EcommLandingPage from "./ecommerce/pages/EcommLandingPage/EcommLandingPage";
import SellerFeedbackPage from "./ecommerce/pages/SellerFeedbackPage/SellerFeedbackPage";
import AddressSetupGate from "./ecommerce/globalcomponents/LocationSetupModal/AddressSetupGate";

const App: React.FC = () => {
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        newestOnTop
        closeOnClick={false}
        pauseOnHover
        draggable
        theme="light"
      />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AddressSetupGate />
          <CartProvider>
            <WishlistProvider>
              <Routes>
                {/* Standalone Authentication Routes (No EcommLayout / Footer) */}
                <Route path="/SignIn" element={<SignInPage />} />
                <Route path="/SignUp" element={<SignUpPage />} />
                <Route
                  path="/ForgotPassword"
                  element={<ForgotPasswordPage />}
                />
                <Route path="/LoginasAdmin" element={<LoginasAdmin />} />

                {/* Ecommerce Routes */}
                <Route element={<EcommLayout />}>
                  {/* <Route path="/" element={<SignIn />} /> */}
                  {/* <Route path="/" element={<LandingPage />} /> */}
                  <Route path="/" element={<RootRoute />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/Orders" element={<OrdersPage />} />
                  <Route
                    path="/ProductReviewPage/:productId"
                    element={<ProductReviewPage />}
                  />

                  <Route path="/HomePage" element={<HomePage />} />
                  <Route path="/Search" element={<SearchPage />} />
                  <Route
                    path="/DetailPage/:id"
                    element={<ProductDetailPage />}
                  />
                  <Route path="/BrowserHistory" element={<BrowserHistory />} />
                  <Route
                    path="/store/:brandSlug"
                    element={<SellerBrandPage />}
                  />
                  <Route
                    path="/seller/:sellerSlug"
                    element={<SellerInfoPage />}
                  />
                  <Route
                    path="/EcommLandingPage"
                    element={<EcommLandingPage />}
                  />

                  <Route
                    path="/Refproductdetails/:id"
                    element={<Refproductdetails />}
                  />
                  <Route
                    path="/track-order/:orderId"
                    element={<TrackPackagePage />}
                  />
                  <Route path="/todays-deals" element={<TodaysDealsPage />} />

                  <Route
                    path="/DigitalProductDetails/:id"
                    element={<DigitalProductDetails />}
                  />
                  <Route
                    path="/DigitalProduct"
                    element={<DigitalProductPage />}
                  />
                  <Route path="/SellerDetail/:id" element={<SellerDetail />} />
                  <Route path="/SellerListing" element={<SellerListing />} />
                  <Route path="/SellerPage/:id" element={<SellerPage />} />

                  <Route
                    path="/Categories/:superCategory?/:parentCategory?/:subCategory?/:childCategory?"
                    element={<CategoryListingPage />}
                  />
                  <Route path="/buy-again" element={<BuyAgainPage />} />
                  <Route path="/category/*" element={<CategoryListingPage />} />

                  <Route path="/Categories" element={<CategoryListingPage />} />

                  <Route path="/RefProducts" element={<RefProduct />} />
                  <Route path="/productlist" element={<ProductList />} />
                  <Route path="/SubCategorie" element={<SubCategorie />} />
                  <Route path="/ChildCategorie" element={<ChildCategorie />} />
                  <Route path="/Cart" element={<CartPage />} />
                  <Route path="/CartPage" element={<CartPage />} />
                  <Route path="/Orders" element={<Orders />} />
                  <Route
                    path="/orders/:orderId"
                    element={<OrderDetailsPage />}
                  />

                  <Route path="/TrackPackage/:orderId" element={<TrackPackagePage />} />
                  <Route
                    path="/DeliveryFeedBack"
                    element={<DeliveryFeedBack />}
                  />
                  <Route
                    path="/seller-feedback/:orderId"
                    element={<SellerFeedbackPage />}
                  />
                  
                  <Route path="/Checkout" element={<CheckoutPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/MiniCategories" element={<MiniCategories />} />
                  <Route path="/SubmitReview/:id" element={<SubmitReview />} />
                  <Route
                    path="/BookAppointment"
                    element={<BookAppointment />}
                  />
                  <Route path="/DoctorPro/:sellerId" element={<DoctorPro />} />
                  <Route
                    path="/CustomerDetails/:sellerId/:productId"
                    element={<CustomerDetails />}
                  />
                  {/* Footer Routes */}
                  <Route path="/CorporateInfo" element={<CorporateInfo />} />
                  <Route path="/OurLeadership" element={<OurLeadership />} />
                  <Route
                    path="/OurLeadershipInside"
                    element={<OurLeadershipInside />}
                  />
                  <Route
                    path="/LeadershipPrinciples"
                    element={<LeadershipPrinciples />}
                  />
                  <Route path="/Advertisement" element={<Advertisement />} />
                  <Route path="/Crs" element={<Crs />} />
                  <Route path="/Ethics" element={<Ethics />} />
                  <Route
                    path="/EmployeeBenifits"
                    element={<EmployeeBenifits />}
                  />
                  <Route path="/Diversity" element={<Diversity />} />
                  <Route path="/OurEmployees" element={<OurEmployees />} />
                  <Route path="/Brands" element={<Brands />} />
                  {/* <Route path="/Partners" element={<Partners />} />
              <Route path="/Blogs" element={<Blogs />} />
              <Route path="/BlogsInside/:id" element={<Blogsinsides />} />
              <Route
                path="/content/:pageUri"
                element={<ContentPageforallFooterLinks />}
              />
              <Route path="/Media" element={<Media />} /> */}
                  <Route path="/WorkWithUs" element={<WorkWithUs />} />
                  <Route path="/Jobs" element={<Jobs />} />
                  <Route path="/JobsInside" element={<JobsInside />} />
                  <Route path="/Magzines" element={<Magzines />} />
                  <Route
                    path="/MagzinesInside/:pageUrl"
                    element={<MagzinesInside />}
                  />
                  {/* invoice */}
                  <Route path="/Invoice/:orderId" element={<Invoice />} />
                  <Route
                    path="/CustRefPayInvoice/:id"
                    element={<CustRefPayInvoice />}
                  />
                  <Route
                    path="/SellRefPayInvoice"
                    element={<SellRefPayInvoice />}
                  />
                </Route>
                {/* User Routes */}
                {/* User Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route element={<UserLayout />}>
                    <Route path="/Dashboard" element={<Dashboard />} />
                    <Route
                      path="/SubsOrderDetail"
                      element={<SubsOrderDetail />}
                    />

                    {/* Personal Detail Routes */}
                    <Route
                      path="/PersonalDetails"
                      element={<PersonalInformationPage />}
                    />
                    <Route
                      path="/PersonalInformation"
                      element={<PersonalInformationPage />}
                    />
                    <Route path="/Kyc" element={<KycPage />} />
                    <Route path="/GlobalKyc" element={<KycPage />} />
                    <Route
                      path="/ChangePassword"
                      element={<ChangePassword />}
                    />
                    <Route
                      path="/ChangeTxnPassword"
                      element={<ChangeTxnPassword />}
                    />
                    {/* Manage Address Routes */}
                    <Route path="/ManageAddress" element={<ManageAddress />} />
                    {/* Team Routes */}
                    <Route
                      path="/Referralcommunity"
                      element={<MyInvitationsPage />}
                    />
                    <Route path="/PartnerGrowth" element={<PartnerGrowth />} />
                    <Route
                      path="/InfinityCommunity"
                      element={<SalarSamriddhiPage />}
                    />
                    <Route
                      path="/LevelWise/:level"
                      element={<SalarSamriddhiMilestonePage />}
                    />
                    <Route
                      path="/User/salar-samriddhi"
                      element={<SalarSamriddhiPage />}
                    />
                    <Route
                      path="/User/salar-samriddhi/:milestoneId"
                      element={<SalarSamriddhiMilestonePage />}
                    />
                    {/* Portfolio Routes */}
                    <Route path="/Portfolio" element={<Portfolio />} />
                    {/* My Orders Routes */}
                    <Route path="/MyOrders" element={<MyOrders />} />
                    <Route
                      path="/OrderDetails/:id"
                      element={<OrderDetails />}
                    />
                    {/* My Stuff Routes */}
                    <Route
                      path="/SalarShopVoucher"
                      element={<SalarShopVoucher />}
                    />
                    <Route
                      path="/ShoppingVoucherDetails"
                      element={<Navigate to="/SalarShopVoucher" replace />}
                    />
                    <Route
                      path="/ShoppingVoucherDetails/:id"
                      element={<ShoppingVoucherDetails />}
                    />

                    <Route path="/Gifts" element={<Gifts />} />
                    <Route path="/GiftDetails" element={<GiftDetails />} />
                    <Route path="/LikedStores" element={<LikedStores />} />
                    <Route path="/ReviewStores" element={<ReviewStores />} />
                    <Route
                      path="/LikedStoreDetails"
                      element={<LikedStoreDetails />}
                    />
                    <Route path="/Offers" element={<Offers />} />
                    <Route path="/OfferDetails" element={<OfferDetails />} />
                    <Route path="/Subscriptions" element={<Subscriptions />} />
                    <Route
                      path="/SubscriptionDetails"
                      element={<SubscriptionDetails />}
                    />
                    <Route path="/LuckyDraw" element={<LuckyDraw />} />
                    {/* My Earnings Routes */}
                    <Route
                      path="/ReferralCommission"
                      element={<ReferralCommission />}
                    />
                    <Route
                      path="/ReferralCommissoinTeam"
                      element={<ReferralCommissoinTeam />}
                    />
                    <Route
                      path="/ReferralCommDetails"
                      element={<ReferralCommDetails />}
                    />
                    <Route
                      path="/SponsorCommission"
                      element={<SponsorCommission />}
                    />
                    <Route
                      path="/LoyaltyRefIncentive"
                      element={<LoyaltyRefIncentive />}
                    />
                    <Route
                      path="/ReferralIncentive"
                      element={<ReferralIncentive />}
                    />
                    <Route path="/AusComm" element={<AusComm />} />
                    <Route
                      path="/ReferralCommLevel"
                      element={<ReferralCommLevel />}
                    />
                    <Route path="/Tree" element={<Tree />} />
                    <Route
                      path="/NovaCommissionTeam"
                      element={<NovaCommissionTeam />}
                    />
                    <Route
                      path="/NovalLevelTeam"
                      element={<NovalLevelTeam />}
                    />
                    <Route path="/PrtCommisson" element={<PrtCommisson />} />
                    <Route
                      path="/PrtCommissonDetails"
                      element={<PrtCommissonDetails />}
                    />

                    <Route path="/MrcCommissons" element={<MrcCommissons />} />
                    <Route
                      path="/MrcCommissonDetails"
                      element={<MrcCommissonDetails />}
                    />
                    <Route path="/SalarCoins" element={<SalarCoins />} />
                    <Route
                      path="/SalarCoinsDetails/:id"
                      element={<SalarCoinsDetails />}
                    />
                    <Route
                      path="/ShoppingAmount"
                      element={<ShoppingAmount />}
                    />
                    <Route
                      path="/ShoppingAmountDetail/:id"
                      element={<ShoppingAmountDetail />}
                    />
                    <Route
                      path="/DailyCommissons"
                      element={<DailyCommissons />}
                    />
                    <Route
                      path="/PartnerGrowthIncentives"
                      element={<PartnerGrowthIncentives />}
                    />
                    <Route path="/SalarUnity" element={<SalarUnity />} />
                    <Route
                      path="/SalarUnityDetails"
                      element={<SalarUnityDetails />}
                    />
                    {/* Wallet Routes */}
                    <Route path="/salar-wallet" element={<SalarWalletPage />} />
                    <Route path="/SalarPay" element={<SalarPay />} />
                    <Route path="/FundTransfer" element={<FundTransfer />} />
                    <Route path="/CreditDebit" element={<CreditDebit />} />

                    <Route path="/RecievedFunds" element={<RecievedFunds />} />
                    <Route
                      path="/RecievedFudsDetails/:transferNumber"
                      element={<RecievedFudsDetails />}
                    />
                    <Route
                      path="/FundTransferHistory"
                      element={<FundTransferHistory />}
                    />
                    <Route
                      path="/FundTransferHistoryDetails/:transferNumber"
                      element={<FundTransferHistoryDetails />}
                    />
                    {/* Withdrawl Routes */}
                    <Route
                      path="/WithdrawlRequest"
                      element={<WithdrawlRequest />}
                    />
                    <Route
                      path="/WithdrawlHistory"
                      element={<WithdrawlHistory />}
                    />
                    <Route
                      path="/WithdrawlHistoryDetails/:id"
                      element={<WithdrawlHistoryDetails />}
                    />
                    <Route
                      path="/BankAccVerification"
                      element={<BankAccVerification />}
                    />
                    <Route path="/PayoutReport" element={<PayoutReport />} />
                    <Route path="/Tax" element={<Tax />} />
                    {/* Tickets Routes */}
                    <Route path="/Tickets" element={<Tickets />} />
                    <Route path="/CreateTickets" element={<CreateTickets />} />
                    <Route
                      path="/TicketMessage/:ticketId"
                      element={<TicketMessage />}
                    />
                    {/* Testimonial Routes */}
                    <Route
                      path="/UserTestimonials"
                      element={<UserTestimonials />}
                    />
                    <Route
                      path="/CreateTestimonials"
                      element={<CreateTestimonials />}
                    />
                    <Route
                      path="/UpdateTestimonial/:id"
                      element={<UpdateTestimonial />}
                    />
                    {/* Games Routes */}
                    <Route path="/Games" element={<Games />} />
                    <Route path="/PlayGames" element={<PlayGames />} />
                    {/* Close Account Routes */}
                    <Route path="/CloseAccount" element={<CloseAccount />} />
                    <Route path="/ClosureAccount" element={<CloseAccount />} />
                    <Route
                      path="/DeActivateAccount"
                      element={<DeActivateAccount />}
                    />
                    {/* Payouts Reciept Routes */}
                    <Route path="/UserPayout" element={<UserPayout />} />
                    <Route
                      path="/UserPayoutsTwo"
                      element={<UserPayoutsTwo />}
                    />
                    <Route
                      path="/CustomerFundTransferReciept"
                      element={<CustomerFundTransferReciept />}
                    />
                    <Route
                      path="/DailyCommissoinDetails"
                      element={<DailyCommissoinDetails />}
                    />
                    <Route
                      path="/AdminFunTransferReciept"
                      element={<AdminFunTransferReciept />}
                    />
                    <Route path="/FoodOrderList" element={<FoodOrderList />} />
                    <Route
                      path="/FoodOrderDetails/:id"
                      element={<FoodOrderDetails />}
                    />
                    <Route
                      path="/FoodSellerFeeback/:id"
                      element={<FoodSellerFeeback />}
                    />
                    <Route
                      path="/FoodProductFeedback/:id"
                      element={<FoodProductFeedback />}
                    />
                    <Route
                      path="/FoodDeliveryFeedback"
                      element={<FoodDeliveryFeedback />}
                    />
                  </Route>
                </Route>
              </Routes>
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
